import { gql } from '@apollo/client';

export const GET_ASSET_UPLOAD_STATUS = gql`
  query GetAssetUploadStatus($assetId: ID!) {
    assetUploadStatus(assetId: $assetId) {
      code
      error
    }
  }
`;

export const CREATE_SPEAKER_PICTURE = gql`
  mutation CreateSpeakerPicture($input: CreatePictureInput!) {
    createPicture(input: $input) {
      ... on CreatePictureSuccess {
        assetId
        uploadLink {
          url
          token
        }
      }
      ... on CreatePictureProblem {
        code
      }
    }
  }
`;
